import api from './api';

class SubscriptionService {
  /**
   * Get available subscription tiers
   */
  async getSubscriptionTiers() {
    const response = await api.get('/subscriptions/tiers');
    return response.data.data;
  }

  /**
   * Get current subscription
   */
  async getCurrentSubscription() {
    const response = await api.get('/subscriptions/current');
    return response.data.data;
  }

  /**
   * Create new subscription
   */
  async createSubscription(tierId, paymentMethodId) {
    const response = await api.post('/subscriptions', {
      tierId,
      paymentMethodId
    });
    return response.data.data;
  }

  /**
   * Cancel subscription
   */
  async cancelSubscription(subscriptionId) {
    const response = await api.post('/subscriptions/cancel', {
      subscriptionId
    });
    return response.data.success;
  }

  /**
   * Check if user can add more properties
   */
  async validatePropertyLimit() {
    const response = await api.get('/subscriptions/validate-property-limit');
    return response.data.data.canAddProperty;
  }
}

export default new SubscriptionService();